import React, { useEffect } from 'react';

const ApplyUserSettings = () => {
  useEffect(() => {
    const applySettings = () => {
      const userSettings = JSON.parse(localStorage.getItem('userSettings'));
      if (userSettings) {
        // Apply brand color
        document.documentElement.style.setProperty('--brand-color', userSettings.brandColor);
        
        // You might want to update a global state or context here as well
      }
    };

    applySettings();
  }, []);

  return null; // This component doesn't render anything
};

export default ApplyUserSettings;